import { apiClient } from '@/auth';
import type { InternalRole } from '@/lib/internalRole';

/** `InternalUserMeResponse` (MNT swagger:17836). */
export type InternalUserMe = {
  /** Active `DBInternalUser` membership — RxFood staff. */
  is_internal_user: boolean;
  /** May impersonate. Independent of `internal_role`. */
  has_sudo?: boolean | null;
  /** Access tier; null when not internal staff. */
  internal_role?: InternalRole | null;
};

export const internalUserApi = {
  /**
   * The caller's internal-staff membership and access tier.
   *
   * Returns 200 with `is_internal_user: false` for an ordinary clinician
   * rather than 403, so it is safe to call unconditionally for every signed-in
   * user — the server is explicit that this is so a client can gate and
   * role-scope its UI in one call.
   *
   * This is the durable source for the tier. The login response carries
   * `internal_role` too, but the portal rebuilds its auth store from the token
   * on reload and the clinician profile has no such field, so anything read
   * only at login is lost on refresh.
   */
  async me(): Promise<InternalUserMe> {
    const res = await apiClient.get<InternalUserMe>('/internal_user/me');
    return res.data;
  },
};
